import { Routes } from "@angular/router";

import { authGuard } from "@azm/core/guards/auth";
import { UserRoles } from "@azm/core/enums/user-roles";
import { roleResolver } from "@azm/core/resolvers/role";
import { SidebarService } from "@azm/core/services/sidebar";
import { sidebarResolver } from "@azm/core/resolvers/sidebar";
import { permissionsGuard } from "@azm/core/guards/permissions";
import { permissionsResolver } from "@azm/core/resolvers/permissions";

import { authRoutes } from "@azm/features/auth";

export const routes: Routes = [
	{
		path: "error",
		loadChildren: () => import("./features/error").then((c) => c.errorRoutes),
	},
	{
		path: "",
		children: [
			{ path: "", redirectTo: "auth", pathMatch: "full" },
			{
				path: "auth",
				data: { isLanding: true },
				canActivate: [authGuard],
				children: authRoutes,
			},
			{
				path: "",
				providers: [SidebarService],
				resolve: { activeRoute: roleResolver, sidebar: sidebarResolver, permissions: permissionsResolver },
				data: { isLanding: false },
				canActivate: [authGuard],
				canActivateChild: [permissionsGuard],
				loadComponent: () => import("./core/components/layout").then((c) => c.Layout),
				children: [
					{
						path: "individual",
						data: { role: UserRoles.Internal },
						loadChildren: () => import("./features/layouts/routes/").then((c) => c.internalRoutes),
					},
					{
						path: "",
						data: { role: UserRoles.Internal },
						loadChildren: () => import("./features/layouts/routes/").then((c) => c.internalRoutes),
					},
				],
			},
		],
	},
	{ path: "**", redirectTo: "error/404" },
];
